import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { BancoOrigemEnum, BancoOrigemEnumNome } from '../../../../../../shared/models/enums/banco-origem-enum';
import { TipoContaBancoEnum } from '../../../../../../shared/models/enums/tipo-conta-banco-enum';
import { MessageService } from '@services/message.service';
import { ContaBancoVincularAoCaixaManual } from '../../../models/conta-banco-vincular-ao-caixa-manual';
import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';
import { UtilsService } from '@services/utils.service';

@Component({
  selector: 'app-conta-banco-dialog',
  standalone: false,

  templateUrl: './conta-banco-dialog.component.html',
  styleUrl: './conta-banco-dialog.component.scss'
})
export class ContaBancoDialogComponent implements OnInit {

  contaCaixaId: number;
  formulario: FormGroup;
  contaBanco: ContaBancoVincularAoCaixaManual | null;

  isCartao: boolean = false;

  title: string = 'Vincular conta bancária à conta do caixa';

  bancoOrigemList: { value: BancoOrigemEnum, label: string }[];
  bancoOrigemMap: Map<BancoOrigemEnum, string> = BancoOrigemEnumNome;

  constructor(
    private formBuilder: FormBuilder,
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private utilsService: UtilsService,
    private dialogRef: MatDialogRef<ContaBancoDialogComponent>
  ) { }

  ngOnInit(): void {
    const contaId = this.contaBanco == null ? 0 : this.contaBanco?.id;

    this.formulario = this.formBuilder.group({
      id: [contaId, Validators.required],
      bancoOrigem: [this.contaBanco?.bancoOrigem, Validators.required],
      saldo: [this.contaBanco?.saldo],
      dataSaldo: [this.contaBanco?.dataSaldo],
      dataLancamentoConciliado: [this.contaBanco?.dataLancamentoConciliado],
    });

    const opcoesBancoOrigem = this.utilsService.mapToOptions(BancoOrigemEnumNome);
    this.bancoOrigemList = opcoesBancoOrigem.filter(opcao =>
      this.isCartao ? opcao.value === BancoOrigemEnum.Xp : opcao.value !== BancoOrigemEnum.Xp
    );

    if (this.isCartao)
      this.title = 'Vincular conta de cartão de crédito à conta do caixa';
  }

  public salvarClick(): void {
    if (!this.formulario.valid) {
      this.messageService.showToastWarning("Preencher campos obrigatórios");
    }

    const contaBanco: ContaBancoVincularAoCaixaManual = {
      id: this.formulario.get('id')?.value,
      contaCaixaId: this.contaCaixaId,
      bancoOrigem: this.formulario.get('bancoOrigem')?.value?.value,
      tipoContaBanco: this.isCartao ? TipoContaBancoEnum.CartaoCredito : TipoContaBancoEnum.ContaCorrente,
      dataLancamentoConciliado: this.formulario.get('dataLancamentoConciliado')?.value,
    }

    if (!this.isCartao) {
      contaBanco.saldo = this.formulario.get('saldo')?.value;
      contaBanco.dataSaldo = this.formulario.get('dataSaldo')?.value;
    }

    this.configuracaoCaixaApiService.vincularContaBancoAContaCaixa(contaBanco).subscribe(() => {
      this.messageService.showToastSuccess("Conta vinculado com sucesso.");
      this.dialogRef.close(true);
    });
  }
}
